import styled from 'styled-components';

export const Buttons = styled.div`
  width: 330px;
  margin-top: 24px;

  display: flex;
  flex-direction: column;
  gap: 16px;
`;
